// extracted by mini-css-extract-plugin
export var button_wraper = "empower-module--button_wraper--755b4";
export var cardblock = "empower-module--cardblock--c6f36";
export var left = "empower-module--left--ba817";
export var right = "empower-module--right--c702e";
export var strategy = "empower-module--strategy--952be";